export default __webpack_public_path__ + "static/media/76t.1d22ac88.jpg";